import { bootstrap } from 'vue-gtag';

export class GoogleAnalyticsRepository {
  startTracking() {
    bootstrap();
  }
}
